"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageLevel = exports.TypographicalEmphasis = exports.RichPartMethodType = exports.MessagePartType = void 0;
/**
 * fragment DatePart on DateMessagePart { name date { iso8601 } } fragment PlainPart on BackwardCompatibilityPlainMessagePart { name plain } fragment PlainText on PlainTextMessagePart { name text } fragment Link on LinkMessagePart { name url label } fragment TypographicalEmphasis on RichTextMessagePartMethodTypographicalEmphasis { method name } fragment RichText on RichTextMessagePart { name methods { __typename ...TypographicalEmphasis } text } query {systemMessage { message { ...PlainPart ...PlainText ...Link ...RichText ...DatePart } }}
 */
var MessagePartType;
(function (MessagePartType) {
    MessagePartType["TEXT"] = "text";
    MessagePartType["DATE"] = "date";
    MessagePartType["LINK"] = "link";
    MessagePartType["RICH_TEXT"] = "rich_text";
})(MessagePartType = exports.MessagePartType || (exports.MessagePartType = {}));
var RichPartMethodType;
(function (RichPartMethodType) {
    RichPartMethodType["TYPOGRAPHICAL_EMPHASIS"] = "typographical_emphasis";
})(RichPartMethodType = exports.RichPartMethodType || (exports.RichPartMethodType = {}));
var TypographicalEmphasis;
(function (TypographicalEmphasis) {
    TypographicalEmphasis["BOLD"] = "bold";
})(TypographicalEmphasis = exports.TypographicalEmphasis || (exports.TypographicalEmphasis = {}));
var ForegroundColorType;
(function (ForegroundColorType) {
    ForegroundColorType["WARN"] = "WARN";
})(ForegroundColorType || (ForegroundColorType = {}));
var MessageLevel;
(function (MessageLevel) {
    MessageLevel["INFO"] = "info";
    MessageLevel["WARN"] = "warn";
})(MessageLevel = exports.MessageLevel || (exports.MessageLevel = {}));
//# sourceMappingURL=ChatInterface.js.map